"use client";

// React binding for the post-purchase entitlement sync (lib/billing/
// entitlement-refresh). Kept beside the store rather than inside a component so
// every surface that wants to show a "syncing your plan…" state reads the same
// latch — the sync is single-flight and app-wide, not per-card.

import { useSyncExternalStore } from "react";

import {
  isEntitlementSyncing,
  subscribeEntitlementSync,
} from "@/lib/billing/entitlement-refresh";

/**
 * True while a bounded entitlement poll is in flight.
 *
 * useSyncExternalStore rather than an effect + setState: the store already
 * exists as a module-level boolean, so this needs no mirrored state (and so
 * trips none of the set-state-in-effect rules the billing components are held
 * to). The server snapshot is `false` — nothing is syncing during SSR, and a
 * hydration that claimed otherwise would flash a syncing notice on every load.
 */
export function useEntitlementSyncing(): boolean {
  return useSyncExternalStore(
    subscribeEntitlementSync,
    isEntitlementSyncing,
    () => false,
  );
}
